import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'filter-help-dialog',
    templateUrl: './filter-help-dialog.component.html',
    styleUrls: ['./filter-help-dialog.component.scss'],
    standalone: false
})
export class FilterHelpDialogComponent {
    constructor(public ref: DynamicDialogRef) {}

    close() {
        this.ref.close();
    }
}
